import axios from "axios";

// http://localhost:3000
// http://31.97.85.229:3000
const api = axios.create({
  baseURL: "https://api.aqvex.com.br",
  //baseURL: "http://localhost:3000",
});

// 🔒 Interceptor para adicionar o token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("@aqvex/token");

    if (token) {
      // Remove aspas extras, caso o token tenha sido salvo com elas
      const cleanToken = token.replace(/^"|"$/g, "");
      config.headers.Authorization = `Bearer ${cleanToken}`;
    }

    return config;
  },
  (error) => {
    // Em caso de erro ao configurar a requisição
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("@aqvex/user");
      localStorage.removeItem("@aqvex/token");
      window.dispatchEvent(new Event("auth:expired"));
    }
    return Promise.reject(error);
  }
);

export default api;
